import TrackingManager from '@ingeniorforeningen/tracking';
import { appInsights } from './appInsights';

const trackingManager = new TrackingManager(runtimeConfig.useGtmProdContainer);
const solutionName = 'sagsoverblik';

const sanitizePathForTracking = (path: string) => {
  // Prevent undesirable regex formatting by Prettier
  // prettier-ignore
  const regExAfterQuestionmark : RegExp = /\?(.*)/;
  return path.replace(regExAfterQuestionmark, '');
};

export const trackPageView = (path: string) => {
  trackingManager.page.view({
    isLoggedIn: true,
    section: solutionName,
    pageTitle: sanitizePathForTracking(path),
  });
  appInsights.trackPageView({ uri: sanitizePathForTracking(path), isLoggedIn: true });
};

export const trackError = (error: Error, errorCode: number) => {
  const typedError = error ?? Error('An untyped error occurred');

  trackingManager.monitor?.exception({
    message: typedError.message,
    severityLevel: 3,
    properties: { errorCode: errorCode },
  });
  appInsights.trackException({
    exception: typedError,
    severityLevel: 3,
    properties: { errorCode: errorCode },
  });
};

export const trackPromotion = (path: string, title: string, url: string, placement: number) => {
  trackingManager.promotion.clicked({
    pageTitle: sanitizePathForTracking(path),
    pageSection: solutionName,
    promotionTitle: title,
    promotionUrl: url,
    promotionPlacement: placement,
  });
  appInsights.trackEvent({
    name: 'Promotion clicked',
    properties: { promotionTitle: title, promotionUrl: url, promotionPlacement: placement },
  });
};

export default trackingManager;
